import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostLimitsFetched, {
	type AiCostLimitPayload,
	type AiCostLimitsFetchedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetched';
import aiCostLimitsFetchFailed, {
	type AiCostLimitsFetchFailedAction,
} from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetchFailed';
import type FetchAiCostLimits from '@Application/AiCostLimits/Limits/Queries/FetchAiCostLimits';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AiCostLimitsFetchedAction | AiCostLimitsFetchFailedAction;

export default (query: FetchAiCostLimits) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<AiCostLimitPayload[]>(
				`${parameters.api.host}/api/accounts/${query.accountId}/ai-cost-limits`,
			);

			const action = aiCostLimitsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostLimitsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
